function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { head, indexOf, last, pathEq } from 'ramda';
import CustomerCareLocaleKeys from '../../../locales/keys';
var HOTKEY_COMBO_UP = 'up';
var HOTKEY_COMBO_DOWN = 'down';

// NOTE: Accompanying bindings should be:
//      downKeyDescriptionText: '<'
//      items: '<',
//      onItemSelected: '&',
//      selectedItem: '<',
//      upKeyDescriptionText: '<'
export var HotkeyNavListController = /*#__PURE__*/function () {
  function HotkeyNavListController(hotkeys, $popupManager) {
    _classCallCheck(this, HotkeyNavListController);
    Object.assign(this, {
      hotkeys: hotkeys,
      localeKeys: CustomerCareLocaleKeys,
      $popupManager: $popupManager
    });
  }
  return _createClass(HotkeyNavListController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.hotkeys.add({
        combo: HOTKEY_COMBO_UP,
        description: this.upKeyDescriptionText,
        callback: function callback(event) {
          if (_this.$popupManager.numberOfOpenPopups() === 0) {
            event.preventDefault();
            var selectedItemIndex = indexOf(_this.selectedItem, _this.items);
            switch (selectedItemIndex) {
              case -1:
              case 0:
                _this.setSelectedItem(last(_this.items));
                break;
              default:
                _this.setSelectedItem(_this.items[selectedItemIndex - 1]);
                break;
            }
          }
        }
      });
      this.hotkeys.add({
        combo: HOTKEY_COMBO_DOWN,
        description: this.downKeyDescriptionText,
        callback: function callback(event) {
          if (_this.$popupManager.numberOfOpenPopups() === 0) {
            event.preventDefault();
            var selectedItemIndex = indexOf(_this.selectedItem, _this.items);
            switch (selectedItemIndex) {
              case -1:
              case _this.items.length - 1:
                _this.setSelectedItem(head(_this.items));
                break;
              default:
                _this.setSelectedItem(_this.items[selectedItemIndex + 1]);
                break;
            }
          }
        }
      });
      this.handleItemSelected = function (item) {
        _this.setSelectedItem(item);
      };
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      if (changesObj.items && changesObj.items.currentValue && changesObj.items.previousValue) {
        if (this.onItemAdded && changesObj.items.currentValue.length > changesObj.items.previousValue.length) {
          this.onItemAdded()();
        } else if (this.onItemRemoved && changesObj.items.currentValue.length < changesObj.items.previousValue.length) {
          this.onItemRemoved()();
        }
      }
    }
  }, {
    key: "hasItems",
    get: function get() {
      return this.items && this.items.length > 0;
    }
  }, {
    key: "isItemsEqual",
    value: function isItemsEqual(selectedItem) {
      return selectedItem && pathEq(this.selectedItem.Id, ['Id'])(selectedItem);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.hotkeys.del(HOTKEY_COMBO_UP);
      this.hotkeys.del(HOTKEY_COMBO_DOWN);
    }
  }, {
    key: "setSelectedItem",
    value: function setSelectedItem(item) {
      this.onItemSelected()(item);
    }
  }]);
}();